import React, { ReactElement } from 'react';
import {
  Col, Row, Tag, Text,
} from 'idsk-react-components';
import './sprievodnyDokumentDetailRow.scss';
import getFileSize from '../../../../function/getFileSize';
import formatDatumUlozenia from '../../../../function/formatDatumUlozenia';

interface Props {
  nazov: string,
  typDokumentu: string,
  velkost: number,
  datumUlozenia?: string,
  povinne: boolean,
  actions: ReactElement,
}

const SprievodnyDokumentDetailRow = ({
  nazov,
  typDokumentu,
  velkost,
  datumUlozenia,
  povinne,
  actions,
}: Props): ReactElement => (
  <Col className="dokument-detail">
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">Názov</Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{nazov}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">Typ dokumentu</Text>
      </div>
      <div className="two-thirds">
        {povinne && (<><Tag size="medium">Povinné</Tag><br /></>)}
        <Text type="p" className="dokument-detail-row-text">{typDokumentu}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">Veľkosť</Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">
          {velkost ? getFileSize(velkost) : ''}
        </Text>
      </div>
    </Row>
    {datumUlozenia && (
      <Row className="dokument-detail-row">
        <div className="one-third">
          <Text type="span" className="information-header">Dátum a čas uloženia</Text>
        </div>
        <div className="two-thirds">
          <Text type="p" className="dokument-detail-row-text">
            {formatDatumUlozenia(datumUlozenia)}
          </Text>
        </div>
      </Row>
    )}
    <Row className="dokument-detail-row">
      {actions}
    </Row>
  </Col>
);

export default SprievodnyDokumentDetailRow;
